// Vuex records module actions
import { hParseToFilterCriteriaObjectRequiredByApi } from '@/utils/helpers';
import { API } from '@/config';

import {
  FILL_LIST,
  SET_FILTERING_CRITERIA,
  SET_PAGE,
} from './mutations-types';

export default {
  async getList({ state, commit }) {
    try {
      const params = {
        page: state.list.page,
      };
      const { records, total } = (await API.get('client/projects/getList', { params })).data.data;
      commit(FILL_LIST, { records, total });
    } catch (err) {
      console.log(err);
    }
  },

  filterList({ state, commit, dispatch }, [{ key, value, label, name }, client]) {
    try {
      const filterCriteria = { ...state.filtering_criteria };
      if (value !== null) {
        filterCriteria[key] = {
          value,
          name,
          label,
        };
      } else {
        delete filterCriteria[key];
      }
      commit(SET_FILTERING_CRITERIA, { ...filterCriteria });
      commit(SET_PAGE, { page: 1 });
      dispatch('getList', client);
    } catch (err) {
      console.log(err);
    }
  },

  clearFilteringCriteria({ commit }) {
    commit(SET_FILTERING_CRITERIA, {});
    commit(SET_PAGE, { page: 1 });
  },

  changePage({ commit, dispatch }, [page, client]) {
    commit(SET_PAGE, { page });
    dispatch('getList', client);
  },
};
